<template>
  <div v-if="_g_ShowStockChartMenu" class="legacy-mobile-tools">
    <header><h2>Herramientas</h2><p>Explora el mercado o consulta el valor seleccionado.</p></header>
    <section v-for="group in toolGroups" :key="group.title">
      <h3>{{ group.title }}</h3>
      <div class="legacy-mobile-tools__grid">
        <button v-for="tool in group.items" :key="tool.action" type="button" :aria-current="isActiveQueryTool(tool.action) ? 'true' : null" data-usage-surface="mobile_tools" :data-usage-action="tool.action" @click="activateTool(tool.action)">
          <span class="material-icons-outlined" aria-hidden="true">{{ tool.icon }}</span>
          <span>{{ tool.label }}</span>
        </button>
      </div>
    </section>
  </div>
</template>
<script>
import { legacyQueryConsumer } from "../models/legacyQuerySelection";
  import APICaller from "@/shared/mixins/APICaller.js";
  import { mapMutations, mapGetters } from "vuex";


  export default {
    mixins:[legacyQueryConsumer, APICaller],
    name: 'StockchartMenu',
    components: {
    },
    data() {
      return {
        toolGroups: [{"title":"Buscar valores","items":[{"icon":"filter_alt","label":"Filtros","action":"_openFilters"},{"icon":"grade","label":"Favoritos","action":"_openFavorites"},{"icon":"workspace_premium","label":"Platinum","action":"_setPlatinumActive"},{"icon":"folder","label":"Búsquedas","action":"_openSearches"},{"icon":"search","label":"Rastrear","action":"_openDescriptionSearch"}]},{"title":"Sobre el valor","items":[{"icon":"info","label":"Análisis E.","action":"_openInfo"},{"icon":"manage_search","label":"Análisis F.","action":"_openFundamental"},{"icon":"home_work","label":"Descripción","action":"_openDescription"},{"icon":"chat_bubble_outline","label":"Comentarios","action":"_openComments"}]},{"title":"Otras herramientas","items":[{"icon":"auto_awesome","label":"Creador","action":"_openSimulator"},{"icon":"edit","label":"Registro","action":"_openNotas"},{"icon":"rocket_launch","label":"Orden","action":"_openBroker"},{"icon":"report_problem","label":"Reportar error","action":"_openError"}]}],
        workspaces: [],
        last_element_active: 1,
        show_link_favorites: false,
        sidebar_right_menu_width: 52,
        parent_component: 'sidebar-content',
        tradingview_container: 'dragable-container',
        show_searches: false,
        numberStocks: '',
        workspace: '',

        open_info: false,
        open_brain: false,
        open_description: false,
        open_comments: false,
        open_notas: false,
        open_error: false,
        open_broker: false,
        open_simulator: false,
      };
    },
    computed: {
        ...mapGetters(['_g_IsUserLogged']),
        ...mapGetters(['_g_User']),
        ...mapGetters(['_g_ToggleBetweenTableAndChart']),
        ...mapGetters(['_g_ShowStockChartMenu']),
        ...mapGetters(['_g_ShowStockFinderFilter']),
        ...mapGetters({changeSelection:'_g_MenuSelectionOut'}),
        ...mapGetters({lastIndex:'_g_IndexMenu'}),
        ...mapGetters({stock_type:'_g_GetTypeStocks'}),
        ...mapGetters(['_g_chart_view']),
        ...mapGetters(['_g_stocks_view']),
        ...mapGetters(['_g_toggle_chart_stocks']),
        ...mapGetters(['_g_open_info']),
        ...mapGetters(['_g_open_fundamental']),
        ...mapGetters(['_g_open_description']),
        ...mapGetters(['_g_open_brain']),
        ...mapGetters(['_g_open_comments']),
        ...mapGetters(['_g_open_notas']),
        ...mapGetters(['_g_open_error']),
        ...mapGetters(['_g_open_order']),
        ...mapGetters(['_g_open_simulator']),
        ...mapGetters(['_g_open_filters']),
        ...mapGetters(['_g_open_favorites']),
        ...mapGetters(['_g_open_searches']),
        ...mapGetters(['_g_open_alarms']),
        ...mapGetters(['_g_TickersFinder']),
             
    },
    methods: {
        isActiveQueryTool(action) {
          const tools = { _openFilters: 'filters', _openFavorites: 'favorites', _setPlatinumActive: 'platinum', _openSearches: 'saved-searches', _openDescriptionSearch: 'description-search' };
          return tools[action] === this.activeQuery.tool;
        },
        activateTool(action) {
          if (!this._g_IsUserLogged) return this._toastIniciaSesion();
          if (this._g_User.is_only_authenticated_user) return this._toastError();
          this[action]();
          this.$emit('tool-opened');
        },
        ...mapMutations(['setToggleBetweenListAndChartInStockchart']),
        ...mapMutations(['setShowStockFinderFilters']),
        ...mapMutations(['setSelectedFavoriteWorkspace']),
        ...mapMutations(['setShowStockChartMenu']),
        ...mapMutations(['isMobileDevice']),
        ...mapMutations(['setStockValue']),
        ...mapMutations(['setMenuSelectionOut']),
        ...mapMutations(['setStockchart']),
        ...mapMutations(['setChartView']),
        ...mapMutations(['setStocksView']),
        ...mapMutations(['setOpenInfo']),
        ...mapMutations(['setOpenFundamental']),
        ...mapMutations(['setOpenDescription']),
        ...mapMutations(['setOpenError']),
        ...mapMutations(['setOpenBrain']),
        ...mapMutations(['setOpenSimulator']),
        ...mapMutations(['setOpenOrder']),
        ...mapMutations(['setOpenNotas']),
        ...mapMutations(['setOpenComments']),
        ...mapMutations(['closeOtherButtons']),
        ...mapMutations(['setOpenFilters']),
        ...mapMutations(['setOpenFavorites']),
        ...mapMutations(['setOpenSearches']),
        ...mapMutations(['setOpenAlarm']),
        ...mapMutations(['setTickersFinder']),
        

        _toggleBetweenListAndChartInStockchart() {
            this.setToggleBetweenListAndChartInStockchart();
        },

        _setStockChart(){
          this.setStockchart();
        },

        _setPlatinumActive(){
          if (this.activeQuery.tool === 'platinum') return;
          if (this.legacyQuery) this.legacyQuery.reset();
          if (this.$route.params.param1 !== 'platinum') this.$router.push('/app/graficador-dinamico/platinum');
          else if (this.legacyQuery) this.legacyQuery.reload();
        },
                
        _openFavoritesLinks() {
        },

        _closeFavoritesLinks() {
        },

        _getStocksInWorkspace() {
          let success = response =>{
            this.numberStocks = response.data.length;
          }

          let url = '/api/v1/stock-finder/stocks/favoritos/' + this.workspace.name

          const successHandler = new APICaller.SuccessHandler(success);
          const failureHandler = new APICaller.FailureHandler('168', 'Error recuperando valores.');

          this._getAPICall(url, successHandler, failureHandler);
        },

        _findFavoritesStocksByName(workspace) {
          this.workspace = workspace;
          this.numberStocks = this._getStocksInWorkspace();
          setTimeout(() => {
            if(this.numberStocks != 0){
              this.show_link_favorites = !this.show_link_favorites;          
              this.setSelectedFavoriteWorkspace(workspace.name);
              if (this.$router.history.current.name === 'Favoritos') {
                this.$vueOnToast.pop('warning', "Ya estás en favoritos");
              }
              else {
                this.$router.push('/app/graficador-dinamico/favorites/' + workspace.name);
              }
            }
            else{
              if(this._g_IsUserLogged){
                this.$vueOnToast.pop('error', "No existen tickers en este workspace", "Por favor añada tickers al workspace" + ' - Error code 003.1');
              }
            } 
          }, 200);
          
                   
        },
        _openSearchesWindow: function(){
          this.show_searches = !this.show_searches;
        },
        _closeSearchWindow: function(){
          this.show_searches = false;
          this.setMenuSelectionOut(5);
        },

        _listWorkspaces: function() {
          if(!this._g_User.is_only_authenticated_user){
            let success = response =>{
              for (let index = 0; index < response.data.folders.length; index++) {
                this.workspaces.push({
                  name: response.data.folders[index][0],
                  color: response.data.folders[index][1],
                  isFavorite: false,
                });
              }
            }
  
            let url = '/api/v1/stock-finder/favorite-folder/list'
  
            const successHandler = new APICaller.SuccessHandler(success);
            const failureHandler = new APICaller.FailureHandler('169', 'No existen tickers en este espacio de trabajo.');
  
            this._getAPICall(url, successHandler, failureHandler);
          }
        },
        _closeFavorites: function(){
          this.show_link_favorites = false;
          this.setMenuSelectionOut(3);
        },

        _toastIniciaSesion : function(){
          this.$vueOnToast.pop('error', "Si quiere acceder a esta herramienta inicie sesión.");
        },

        _openFilters(){
          this.closeOtherButtons("filters")
          this.setOpenFilters();
          this.setShowStockFinderFilters();         

          if (this._g_open_filters == false) {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(false);
            } else{
              this.setStocksView(false);
            }
          }
          else {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(true);
            } else{
              this.setStocksView(true);
            }
          }

        },

        _openFavorites(){
          this.closeOtherButtons("favorites")
          this.setOpenFavorites();
          
          if (this._g_open_favorites == false) {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(false);
            } else{
              this.setStocksView(false);
            }
          }
          else {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(true);
            } else{
              this.setStocksView(true);
            }
          }

        },

        _openSearches(){
          this.closeOtherButtons("searches")
          this.setOpenSearches();

          if (this._g_open_searches == false) {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(false);
            } else{
              this.setStocksView(false);
            }
          }
          else {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(true);
            } else{
              this.setStocksView(true);
            }
          }

        },

        _openInfo(){
          this.closeOtherButtons("info");
          this.setOpenInfo();

          if (this._g_open_info == false) {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(false);
            } else{
              this.setStocksView(false);
            }
          }
          else {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(true);
            } else{
              
              this.setStocksView(true);
            }
          }
        },

        _openFundamental(){
          this.closeOtherButtons("fundamental");
          this.setOpenFundamental();

          if (this._g_open_fundamental == false) {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(false);
            } else{
              this.setStocksView(false);
            }
          }
          else {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(true);
            } else{
              this.setStocksView(true);
            }
          }
        },

        _openBrain(){
          this.closeOtherButtons("brain");
          this.setOpenBrain();
          
          if (this._g_open_brain == false) {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(false);
            } else{
              this.setStocksView(false);
            }
          }
          else {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(true);
            } else{
              
              this.setStocksView(true);
            }
          }
        },

        _openDescription(){
          this.closeOtherButtons("description");
          this.setOpenDescription();

          if (this._g_open_description == false) {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(false);
            } else{
              this.setStocksView(false);
            }
          }
          else {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(true);
            } else{
              this.setStocksView(true);
            }
          }
        },

        _openComments(){
          this.closeOtherButtons("comments");
          this.setOpenComments();
          if (this._g_open_comments == false) {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(false);
            } else{
              this.setStocksView(false);
            }
          }
          else {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(true);
            } else{
              this.setStocksView(true);
            }
          }
        },

        _openNotas(){
          this.closeOtherButtons("notas");
          this.setOpenNotas();
          if (this._g_open_notas == false) {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(false);
            } else{
              this.setStocksView(false);
            }
          }
          else {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(true);
            } else{
              this.setStocksView(true);
            }
          }
        },

        _openAlarm(){
          this.closeOtherButtons("alarms");
          this.setOpenAlarm();
          if (this._g_open_alarm == false) {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(false);
            } else{
              this.setStocksView(false);
            }
          }
          else {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(true);
            } else{
              this.setStocksView(true);
            }
          }
        },

        _openError(){
          this.closeOtherButtons("error");
          this.setOpenError();
          if (this._g_open_error == false) {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(false);
            } else{
              this.setStocksView(false);
            }
          }
          else {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(true);
            } else{
              this.setStocksView(true);
            }
          }
        },

        _openBroker(){
          this.closeOtherButtons("broker");
          this.setOpenOrder();
          if (this._g_open_order == false) {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(false);
            } else{
              this.setStocksView(false);
            }
          }
          else {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(true);
            } else{
              this.setStocksView(true);
            }
          }
        },

        _openSimulator(){
          this.closeOtherButtons("simulator");
          this.setOpenSimulator();
         if (this._g_open_simulator == false) {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(false);
            } else{
              this.setStocksView(false);
            }
          }
          else {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(true);
            } else{
              this.setStocksView(true);
            }
          }
        },

        _openDescriptionSearch(){
          this.closeOtherButtons("descriptionSearch");
          this.setTickersFinder();
         if (this._g_TickersFinder == false) {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(false);
            } else{
              this.setStocksView(false);
            }
          }
          else {
            if(this._g_toggle_chart_stocks == 'chart'){
              this.setChartView(true);
            } else{
              this.setStocksView(true);
            }
          }
        },

        _toastError(){
          let toast = {type: 'warning', body: 'Su plan actual no tiene acceso a esta herramienta. PULSE AQUÍ para cambiar de plan.', clickHandler: function(){
            window.location.replace("/app/store");
          }};
          this.$vueOnToast.pop(toast);
        }
    },
}
</script>

<style scoped>
.legacy-mobile-tools { color: var(--color-text-primary); }
header { padding: 20px 16px 12px; }
h2 { font-size: 20px; margin: 0 0 6px; }
header p { margin: 0; font-size: 13px; opacity: .7; line-height: 1.5; }
section { padding: 16px; border-bottom: 1px solid #8883; }
h3 { margin: 0 0 8px; font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .6px; opacity: .7; }
.legacy-mobile-tools__grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 4px 8px; }
button { min-width: 0; min-height: 52px; display: flex; align-items: center; gap: 10px; padding: 8px 4px; border: 0; border-radius: 5px; background: transparent; color: inherit; font: inherit; font-size: 13px; text-align: left; cursor: pointer; touch-action: manipulation; }
button .material-icons-outlined { font-size: 23px; color: #008aa9; }
button:active, button:hover { background: #00add90c; }
button[aria-current="true"] { background: #e2f3fc; color: #007bb5; box-shadow: inset 3px 0 #008bd2; font-weight: 600; }
button:focus-visible { outline: 2px solid #007e9e; outline-offset: 2px; }
@media (orientation: landscape) and (min-width: 600px) { .legacy-mobile-tools__grid { grid-template-columns: repeat(5, minmax(0, 1fr)); } }
</style>
